import { Group } from '@mantine/core';
import { useStyles } from './NavBarWrapper.styles';

interface NavBarWrapperProps {
	children: React.ReactNode;
	bg?: string;
	sticky?: boolean;
}

export function NavBarWrapper({ children, bg, sticky }: NavBarWrapperProps) {
	const { classes } = useStyles({ sticky });

	return (
		<Group className={classes.wrapper} bg={bg}>
			{children}
		</Group>
	);
}
